import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../auth/context';
import { makeApiClient, type ApiClient } from './client';
import { readEnv } from '../env';

export function useApi(): ApiClient {
  const auth = useAuth();
  const navigate = useNavigate();
  return useMemo(() => makeApiClient({
    baseUrl: readEnv().relayBaseUrl,
    getJwt: auth.getJwt,
    onUnauthorized: () => {
      auth.logout();
      void navigate('/login', { replace: true });
    },
  }), [auth, navigate]);
}
